export const searchMasterOperatorMock = {
	operatorList: [
		{
			fpId: '0',
			name: 'Demosite',
			isMasterOperator: true,
			parentOperator: 0,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '1',
			name: 'Sylph',
			isMasterOperator: true,
			parentOperator: 1,
			resellerId: 0,
			apiWhiteList: ['124', '23'],
		},
		{
			fpId: '2',
			name: 'GamingWorld',
			isMasterOperator: true,
			parentOperator: 2,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '3',
			name: 'DrGaming',
			isMasterOperator: true,
			parentOperator: 3,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '5',
			name: 'SBOBET',
			isMasterOperator: true,
			parentOperator: 5,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '6',
			name: 'Digient',
			isMasterOperator: true,
			parentOperator: 6,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '7',
			name: 'BetAdvance',
			isMasterOperator: true,
			parentOperator: 7,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '8',
			name: 'Superswan',
			isMasterOperator: true,
			parentOperator: 8,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '9',
			name: '568Win',
			isMasterOperator: true,
			parentOperator: 9,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '11',
			name: 'IBC',
			isMasterOperator: true,
			parentOperator: 11,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '12',
			name: 'SylphT',
			isMasterOperator: true,
			parentOperator: 12,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '13',
			name: 'DragonSoft',
			isMasterOperator: true,
			parentOperator: 13,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '14',
			name: 'SylphIBC',
			isMasterOperator: true,
			parentOperator: 14,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '15',
			name: 'ABLIVECASINO',
			isMasterOperator: true,
			parentOperator: 15,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '16',
			name: 'Vin88',
			isMasterOperator: true,
			parentOperator: 16,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '17',
			name: 'Xitment',
			isMasterOperator: true,
			parentOperator: 17,
			resellerId: 0,
			apiWhiteList: ['32', '12'],
		},
		{
			fpId: '18',
			name: 'EasyGaming',
			isMasterOperator: true,
			parentOperator: 18,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '19',
			name: 'EasyGame88',
			isMasterOperator: true,
			parentOperator: 19,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '21',
			name: 'WM-W21test',
			isMasterOperator: true,
			parentOperator: 21,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '22',
			name: 'AUQI-hbo',
			isMasterOperator: true,
			parentOperator: 22,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '23',
			name: 'Ambsuperslot',
			isMasterOperator: true,
			parentOperator: 23,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '24',
			name: 'PGS',
			isMasterOperator: true,
			parentOperator: 24,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '25',
			name: 'Fortuno',
			isMasterOperator: true,
			parentOperator: 25,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '26',
			name: 'MGP',
			isMasterOperator: true,
			parentOperator: 26,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '27',
			name: 'Hwin168-DSTBET',
			isMasterOperator: true,
			parentOperator: 27,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '28',
			name: 'Hwin168',
			isMasterOperator: true,
			parentOperator: 28,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '30',
			name: 'xtu168',
			isMasterOperator: true,
			parentOperator: 30,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '31',
			name: 'Great Ent Co',
			isMasterOperator: true,
			parentOperator: 31,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '32',
			name: 'EXP',
			isMasterOperator: true,
			parentOperator: 32,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '33',
			name: 'GamingSoft-T',
			isMasterOperator: true,
			parentOperator: 33,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '34',
			name: 'GamingSoft-S',
			isMasterOperator: true,
			parentOperator: 34,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '35',
			name: 'HWFNKWENFA',
			isMasterOperator: true,
			parentOperator: 35,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '36',
			name: 'GPlay',
			isMasterOperator: true,
			parentOperator: 36,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '37',
			name: 'ThirtyThree',
			isMasterOperator: true,
			parentOperator: 37,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '38',
			name: 'Immortal',
			isMasterOperator: true,
			parentOperator: 38,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '39',
			name: 'istar',
			isMasterOperator: true,
			parentOperator: 39,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '41',
			name: 'Mrslotty-ire',
			isMasterOperator: true,
			parentOperator: 41,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '42',
			name: 'Spadeclub',
			isMasterOperator: true,
			parentOperator: 42,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '43',
			name: 'ism',
			isMasterOperator: true,
			parentOperator: 43,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '44',
			name: 'Big Data Centre SDN',
			isMasterOperator: true,
			parentOperator: 44,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '45',
			name: 'tg',
			isMasterOperator: true,
			parentOperator: 45,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '46',
			name: 'Egadmin',
			isMasterOperator: true,
			parentOperator: 46,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '47',
			name: 'Razer',
			isMasterOperator: true,
			parentOperator: 47,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '48',
			name: 'Markor',
			isMasterOperator: true,
			parentOperator: 48,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '49',
			name: 'HWFNKWF',
			isMasterOperator: true,
			parentOperator: 49,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '50',
			name: 'X2',
			isMasterOperator: true,
			parentOperator: 50,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '51',
			name: 'Ironman',
			isMasterOperator: true,
			parentOperator: 51,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '52',
			name: 'Winbet',
			isMasterOperator: true,
			parentOperator: 52,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '53',
			name: 'XiaoXiang',
			isMasterOperator: true,
			parentOperator: 53,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '54',
			name: 'JXIT',
			isMasterOperator: true,
			parentOperator: 54,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '55',
			name: 'USSBET',
			isMasterOperator: true,
			parentOperator: 55,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '56',
			name: 'Neftsoft',
			isMasterOperator: true,
			parentOperator: 56,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '57',
			name: 'Hwin168-rapa',
			isMasterOperator: true,
			parentOperator: 57,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '58',
			name: 'Hwin168-HWUP8FK',
			isMasterOperator: true,
			parentOperator: 58,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '59',
			name: 'Leekie',
			isMasterOperator: true,
			parentOperator: 59,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '60',
			name: 'Betksh',
			isMasterOperator: true,
			parentOperator: 60,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '61',
			name: 'WS',
			isMasterOperator: true,
			parentOperator: 61,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '62',
			name: 'Hwin168-Gbet',
			isMasterOperator: true,
			parentOperator: 62,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '63',
			name: 'GST',
			isMasterOperator: true,
			parentOperator: 63,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '64',
			name: 'HWTGBTFNK',
			isMasterOperator: true,
			parentOperator: 64,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '65',
			name: 'Okbet',
			isMasterOperator: true,
			parentOperator: 65,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '99',
			name: 'maple',
			isMasterOperator: true,
			parentOperator: 99,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '168',
			name: 'JClub777',
			isMasterOperator: true,
			parentOperator: 168,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '1680',
			name: 'demogame',
			isMasterOperator: true,
			parentOperator: 1680,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '9999',
			name: 'kevin',
			isMasterOperator: true,
			parentOperator: 9999,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '360001',
			name: 'GPlay-PSG2020',
			isMasterOperator: true,
			parentOperator: 360001,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '360002',
			name: 'GPlay-Asia999',
			isMasterOperator: true,
			parentOperator: 360002,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '360003',
			name: 'GPlay-Supper777',
			isMasterOperator: true,
			parentOperator: 360003,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '360004',
			name: 'GPlay-TARIK',
			isMasterOperator: true,
			parentOperator: 360004,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '360005',
			name: 'GPlay-betaday888',
			isMasterOperator: true,
			parentOperator: 360005,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '360006',
			name: 'Gplay-Msnslot',
			isMasterOperator: true,
			parentOperator: 360006,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '360100',
			name: 'GPlay-12P66G',
			isMasterOperator: true,
			parentOperator: 360100,
			resellerId: 0,
			apiWhiteList: [],
		},
		{
			fpId: '360200',
			name: 'GPlay-GP119',
			isMasterOperator: true,
			parentOperator: 360200,
			resellerId: 0,
			apiWhiteList: [],
		},
	],
};

export default searchMasterOperatorMock;
